import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input, ViewChild } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { BaseForm } from '@forms/base.form';
import { environment } from '@env/environment';

@Component({
    selector: 'app-job-board-settings-embedded-information',
    templateUrl: './job-board-settings-embedded.form.html',
    styleUrls: ['./job-board-settings-embedded.style.scss'],
})
export class JobBoardSettingsEmbeddedForm extends BaseForm {
    @Input({ required: true }) companySlug!: string;
    @ViewChild('copyTooltip', { static: true }) copyTooltip!: MatTooltip;

    isCopyTooltipDisabled = true;

    constructor(private clipboard: Clipboard) {
        super();
    }

    get embedCode(): string {
        return (
            `<div id="HumiJobBoard" data-company="${this.companySlug}"></div>` +
            `<script src="https://${this.companySlug}.${environment.jobBoardDomain}/embed.js" async defer></script>`
        );
    }

    onClick(event: MouseEvent): void {
        if (event.target instanceof HTMLTextAreaElement) {
            event.target.select();
            this.copyEmbedCodeToClipboard();
        }
    }

    private copyEmbedCodeToClipboard(): void {
        this.clipboard.copy(this.embedCode);

        this.isCopyTooltipDisabled = false;

        // This block is to get the tooltip component to behave as a popover.
        // It initially waits for the re-render following the change to
        // `isCopyTooltipDisabled` before displaying the tooltip and then
        // hiding it again after 2 seconds.
        setTimeout(() => {
            this.copyTooltip.show();

            setTimeout(() => {
                this.isCopyTooltipDisabled = true;
            }, 2000);
        }, 1);
    }
}
